export const medcheckPrescriptionTrainingDatabase = {
  "version": "1.0.0",
  "datasetName": "MedCheck Bangladesh Prescription Ground Truth Dataset",
  "createdFor": "MedCheck MindSpark'26 showcase",
  "createdAt": "2026-07-04",
  "importantNote": "Use this as a local verified extraction/correction dataset and medicine resolver. Do not use it as fake/demo data in user-facing pages. Public demos should anonymize patient identifiers unless consent exists.",
  "privacy": {
    "containsPatientData": true,
    "recommendedPublicMode": "anonymize patient.name, patient.id, personalId before public deployment",
    "allowedUse": "resolver correction, OCR evaluation, saved real-analysis fixture testing"
  },
  "timeSlotRules": {
    "morning": "05:00-11:59",
    "noon": "12:00-15:59",
    "evening": "16:00-19:59",
    "night": "20:00-04:59",
    "patterns": {
      "1+0+0": [
        "morning"
      ],
      "0+1+0": [
        "noon"
      ],
      "0+0+1": [
        "night"
      ],
      "1+0+1": [
        "morning",
        "night"
      ],
      "1+1+1": [
        "morning",
        "noon",
        "night"
      ],
      "2+0+2": [
        "morning",
        "night"
      ],
      "1+1+0": [
        "morning",
        "noon"
      ],
      "0+1+1": [
        "noon",
        "night"
      ]
    },
    "foodTimingPatterns": {
      "after meal": "after_food",
      "after food": "after_food",
      "খাবার পরে": "after_food",
      "খাবার পর": "after_food",
      "before meal": "before_food",
      "before food": "before_food",
      "খাবার আগে": "before_food",
      "আধা ঘন্টা পূর্বে": "30_min_before_food"
    }
  },
  "medicineKnowledgeBase": [
    {
      "brand": "Aquafresh",
      "aliases": [
        "Aquafresh E/D",
        "AquaFresh E/D",
        "Aquafresh eye drop"
      ],
      "generic": "Carboxymethylcellulose Sodium",
      "form": "ophthalmic solution",
      "category": "lubricant eye drop",
      "source": "medex_carboxymethylcellulose"
    },
    {
      "brand": "Napa",
      "aliases": [
        "Napa 500",
        "Napa Rapid"
      ],
      "generic": "Paracetamol",
      "form": "tablet",
      "category": "analgesic/antipyretic",
      "source": "medex_napa"
    },
    {
      "brand": "Fexo",
      "aliases": [
        "Fexo 120"
      ],
      "generic": "Fexofenadine Hydrochloride",
      "form": "tablet",
      "category": "antihistamine",
      "source": "medex_fexofenadine"
    },
    {
      "brand": "Fenadin",
      "aliases": [
        "Fenadin 120",
        "Fendin 120",
        "Ferdin 120"
      ],
      "generic": "Fexofenadine Hydrochloride",
      "form": "tablet",
      "category": "antihistamine",
      "source": "medex_fenadin"
    },
    {
      "brand": "Furotil Plus",
      "aliases": [
        "Furotil Plus 250/62.5"
      ],
      "generic": "Cefuroxime Axetil + Clavulanic Acid",
      "form": "tablet",
      "category": "antibiotic",
      "source": "hpl_furotil_plus"
    },
    {
      "brand": "Aeron",
      "aliases": [
        "Aeron 10"
      ],
      "generic": "Montelukast Sodium",
      "form": "tablet",
      "category": "anti-asthma/anti-allergy",
      "source": "medex_aeron"
    },
    {
      "brand": "Oxofylline",
      "aliases": [
        "Oxofyline",
        "Oxofylline 400",
        "Doxofylline 400"
      ],
      "generic": "Doxophylline",
      "form": "tablet",
      "category": "bronchodilator",
      "source": "medex_doxophylline"
    },
    {
      "brand": "Flamex",
      "aliases": [
        "Flamex 400"
      ],
      "generic": "Ibuprofen",
      "form": "tablet",
      "category": "NSAID/pain relief",
      "source": "aci_flamex"
    },
    {
      "brand": "ORS",
      "aliases": [
        "Oral Rehydration Salts"
      ],
      "generic": "Oral Rehydration Salts",
      "form": "solution/powder",
      "category": "rehydration",
      "source": "clinical_common"
    },
    {
      "brand": "Afrin",
      "aliases": [
        "Afrin nasal drop",
        "Afun nasal drop",
        "Afrin 0.05%"
      ],
      "generic": "Oxymetazoline Hydrochloride",
      "form": "nasal drop",
      "category": "nasal decongestant",
      "source": "medex_afrin"
    },
    {
      "brand": "Othin",
      "aliases": [
        "Othin 20",
        "Othin 20mg"
      ],
      "generic": "unknown",
      "form": "tablet",
      "category": "needs verification",
      "source": "manual_review"
    },
    {
      "brand": "Permethrin Cream",
      "aliases": [
        "PERMETHRIN CREAM 5%",
        "Permethrin 5%"
      ],
      "generic": "Permethrin",
      "form": "cream",
      "category": "scabicide",
      "source": "medex_permethrin"
    },
    {
      "brand": "Cefuroxime Syrup",
      "aliases": [
        "Cefuroxime Syp"
      ],
      "generic": "Cefuroxime",
      "form": "syrup",
      "category": "antibiotic",
      "source": "clinical_common"
    },
    {
      "brand": "Cetirizine Syrup",
      "aliases": [
        "CETIRIZINE SYRUP"
      ],
      "generic": "Cetirizine Hydrochloride",
      "form": "syrup",
      "category": "antihistamine",
      "source": "clinical_common"
    },
    {
      "brand": "Naproxen + Esomeprazole",
      "aliases": [
        "Naproxen 375 mg + Esomeprazole 20 mg"
      ],
      "generic": "Naproxen + Esomeprazole",
      "form": "tablet",
      "category": "NSAID + PPI",
      "source": "clinical_common"
    },
    {
      "brand": "Vitamin B1 B6 B12",
      "aliases": [
        "Vitamin B1, B6 & B12",
        "Neuro B"
      ],
      "generic": "Thiamine + Pyridoxine + Cyanocobalamin",
      "form": "tablet",
      "category": "vitamin/neurotropic",
      "source": "medex_b1_b6_b12"
    },
    {
      "brand": "Baclofen",
      "aliases": [
        "Baclofen 10 mg"
      ],
      "generic": "Baclofen",
      "form": "tablet",
      "category": "muscle relaxant",
      "source": "medex_baclofen"
    },
    {
      "brand": "Clonazepam",
      "aliases": [
        "Clonazepam 0.5mg",
        "Rivotril 0.5mg"
      ],
      "generic": "Clonazepam",
      "form": "tablet",
      "category": "benzodiazepine",
      "source": "medex_rivotril"
    },
    {
      "brand": "Pregabalin",
      "aliases": [
        "Pregaba",
        "Pregabalin 25 mg",
        "Pregabalin 75 mg"
      ],
      "generic": "Pregabalin",
      "form": "capsule",
      "category": "neuropathic pain medicine",
      "source": "medex_pregabalin"
    },
    {
      "brand": "Montelukast",
      "aliases": [
        "Montelukast 10 mg",
        "Monocast"
      ],
      "generic": "Montelukast Sodium",
      "form": "tablet",
      "category": "anti-asthma/anti-allergy",
      "source": "medex_montelukast"
    },
    {
      "brand": "Pantoprazole",
      "aliases": [
        "Pantoprazole 20 mg"
      ],
      "generic": "Pantoprazole Sodium",
      "form": "tablet",
      "category": "PPI/gastric protection",
      "source": "medex_pantoprazole"
    },
    {
      "brand": "Calcium carbonate + Vitamin D",
      "aliases": [
        "Calcium carbonate 500mg + Vitamin D",
        "Calcium carbonate + Vitamin D Tab"
      ],
      "generic": "Calcium Carbonate + Vitamin D",
      "form": "tablet",
      "category": "calcium/vitamin supplement",
      "source": "medex_calcium"
    }
  ],
  "interactionRules": [
    {
      "pair": [
        "Pregabalin",
        "Clonazepam"
      ],
      "severity": "caution",
      "type": "sedation/fall-risk",
      "patientMessage": "May increase sleepiness, dizziness, and fall risk. Avoid driving and confirm with doctor/pharmacist if excessive drowsiness occurs.",
      "banglaMessage": "ঘুম ঘুম ভাব, মাথা ঘোরা ও পড়ে যাওয়ার ঝুঁকি বাড়তে পারে। অতিরিক্ত ঘুমভাব হলে ডাক্তার/ফার্মাসিস্টের সাথে কথা বলুন।"
    },
    {
      "pair": [
        "Naproxen",
        "Ibuprofen"
      ],
      "severity": "needs_review",
      "type": "NSAID overlap",
      "patientMessage": "Multiple NSAID pain medicines should not be combined without doctor advice.",
      "banglaMessage": "ডাক্তারের পরামর্শ ছাড়া একাধিক NSAID ব্যথার ওষুধ একসাথে খাবেন না।"
    }
  ],
  "prescriptions": [
    {
      "id": "rx_diu_handwritten_eye_2026_01_22",
      "sourceImage": "2.jpg",
      "templateType": "DIU Medical Center handwritten",
      "patient": {
        "name": "Nishet Tabassum",
        "id": "AGP-253-55-023",
        "age": "20",
        "sex": "Female",
        "date": "22.01.26"
      },
      "doctor": {
        "name": "",
        "hospital": "DIU Medical Center, Daffodil International University"
      },
      "complaints": [
        "Redness, itching and tearing of both eyes"
      ],
      "possibleContext": [
        "Eye irritation/allergy/dryness clue; confirm diagnosis with doctor"
      ],
      "medicines": [
        {
          "rawLine": "Aquafresh E/D — 1 drop in each eye 4 times daily — 7 days",
          "brandName": "Aquafresh E/D",
          "genericName": "Carboxymethylcellulose Sodium",
          "form": "eye drop",
          "strength": "not specified",
          "dose": "1 drop in each eye",
          "frequencyPattern": "4 times daily",
          "timeSlots": [
            "morning",
            "noon",
            "evening",
            "night"
          ],
          "foodTiming": "not_applicable",
          "duration": "7 days",
          "englishInstruction": "Use 1 drop in each eye 4 times daily for 7 days.",
          "banglaInstruction": "প্রতিটি চোখে ১ ফোঁটা করে দিনে ৪ বার ৭ দিন ব্যবহার করবেন.",
          "confidence": 0.92,
          "needsReview": false,
          "reviewReason": ""
        }
      ],
      "nonMedicineFindings": []
    },
    {
      "id": "rx_diu_printed_cold_sore_throat_2026_02_23",
      "sourceImage": "3.jpg",
      "templateType": "DIU Medical Center printed + handwritten",
      "patient": {
        "name": "Mashriya Mehjabin",
        "id": "253-55-022",
        "age": "21",
        "sex": "",
        "date": "02/23/2026 14:46:50"
      },
      "doctor": {
        "name": "Dr. Aysha Akhter",
        "hospital": "Daffodil Medical Center"
      },
      "complaints": [
        "Fever with common cold and sore throat for 10 days"
      ],
      "vitals": {
        "bp": "60/40 mmHg (handwritten, verify)",
        "pulse": "70/min"
      },
      "possibleContext": [
        "Fever/common cold/sore throat treatment clue; verify diagnosis with doctor"
      ],
      "medicines": [
        {
          "rawLine": "Napa (Tab) 500mg | 1+1+1 | 7 days | after meal",
          "brandName": "Napa",
          "genericName": "Paracetamol",
          "form": "tablet",
          "strength": "500 mg",
          "dose": "1 tablet",
          "frequencyPattern": "1+1+1",
          "timeSlots": [
            "morning",
            "noon",
            "night"
          ],
          "foodTiming": "after_food",
          "duration": "7 days",
          "englishInstruction": "Take 1 tablet after meal in the morning, noon, and night for 7 days.",
          "banglaInstruction": "খাবারের পরে সকাল, দুপুর ও রাতে ১টি ট্যাবলেট ৭ দিন খাবেন.",
          "confidence": 0.98,
          "needsReview": false,
          "reviewReason": ""
        },
        {
          "rawLine": "Fexo (Tab) 120mg | 0+0+1 | 7 days",
          "brandName": "Fexo",
          "genericName": "Fexofenadine Hydrochloride",
          "form": "tablet",
          "strength": "120 mg",
          "dose": "1 tablet",
          "frequencyPattern": "0+0+1",
          "timeSlots": [
            "night"
          ],
          "foodTiming": "not_specified",
          "duration": "7 days",
          "englishInstruction": "Take 1 tablet at night for 7 days.",
          "banglaInstruction": "রাতে ১টি ট্যাবলেট ৭ দিন খাবেন.",
          "confidence": 0.98,
          "needsReview": false,
          "reviewReason": ""
        },
        {
          "rawLine": "Crossed/overwritten medicine line, possibly Reni 100mg or Dromax 400mg",
          "brandName": "Unclear overwritten medicine",
          "genericName": "unknown",
          "form": "tablet",
          "strength": "100 mg / 400 mg (unclear)",
          "dose": "1 tablet",
          "frequencyPattern": "0+0+1",
          "timeSlots": [
            "night"
          ],
          "foodTiming": "after_food",
          "duration": "3 days",
          "englishInstruction": "This overwritten medicine needs manual confirmation before use.",
          "banglaInstruction": "এই কাটাকাটি/ওভাররাইট করা ওষুধটি ব্যবহারের আগে নিশ্চিত করতে হবে.",
          "confidence": 0.45,
          "needsReview": true,
          "reviewReason": "Overwritten/crossed prescription line is not safely readable"
        },
        {
          "rawLine": "Furotil Plus (Tab) 250/62.5mg | 1+0+1 | 7 days | after meal",
          "brandName": "Furotil Plus",
          "genericName": "Cefuroxime Axetil + Clavulanic Acid",
          "form": "tablet",
          "strength": "250 mg + 62.5 mg",
          "dose": "1 tablet",
          "frequencyPattern": "1+0+1",
          "timeSlots": [
            "morning",
            "night"
          ],
          "foodTiming": "after_food",
          "duration": "7 days",
          "englishInstruction": "Take 1 tablet after meal in the morning and night for 7 days.",
          "banglaInstruction": "খাবারের পরে সকাল ও রাতে ১টি ট্যাবলেট ৭ দিন খাবেন.",
          "confidence": 0.96,
          "needsReview": false,
          "reviewReason": ""
        },
        {
          "rawLine": "Inf. N/S (1L) — at 30 drops/min — Done",
          "brandName": "Normal Saline",
          "genericName": "Sodium Chloride 0.9%",
          "form": "IV infusion",
          "strength": "1 L",
          "dose": "30 drops/min",
          "frequencyPattern": "completed",
          "timeSlots": [],
          "foodTiming": "not_applicable",
          "duration": "done",
          "englishInstruction": "Normal saline infusion was marked as done.",
          "banglaInstruction": "নরমাল স্যালাইন ইনফিউশন সম্পন্ন হিসেবে লেখা আছে.",
          "confidence": 0.9,
          "needsReview": false,
          "reviewReason": ""
        }
      ],
      "nonMedicineFindings": [
        "Lab test: CBC with ESR",
        "Lab test: CRP"
      ]
    },
    {
      "id": "rx_diu_printed_productive_cough_2026_02_26",
      "sourceImage": "4.jpg",
      "templateType": "DIU Medical Center printed",
      "patient": {
        "name": "Sazida Jannat Onti",
        "id": "",
        "age": "20",
        "sex": "",
        "date": "02/26/2026 12:53:02"
      },
      "doctor": {
        "name": "Dr. Aysha Akhter",
        "hospital": "Daffodil Medical Center"
      },
      "complaints": [
        "Fever with common cold and productive cough for 5 days"
      ],
      "possibleContext": [
        "Fever/cold/productive cough treatment clue; verify diagnosis with doctor"
      ],
      "medicines": [
        {
          "rawLine": "Napa (Tab) 500mg | 1+1+1 | 7 days | after meal",
          "brandName": "Napa",
          "genericName": "Paracetamol",
          "form": "tablet",
          "strength": "500 mg",
          "dose": "1 tablet",
          "frequencyPattern": "1+1+1",
          "timeSlots": [
            "morning",
            "noon",
            "night"
          ],
          "foodTiming": "after_food",
          "duration": "7 days",
          "englishInstruction": "Take 1 tablet after meal in the morning, noon, and night for 7 days.",
          "banglaInstruction": "খাবারের পরে সকাল, দুপুর ও রাতে ১টি ট্যাবলেট ৭ দিন খাবেন.",
          "confidence": 0.99,
          "needsReview": false,
          "reviewReason": ""
        },
        {
          "rawLine": "Fexo (Tab) 120mg | 0+0+1 | 7 days",
          "brandName": "Fexo",
          "genericName": "Fexofenadine Hydrochloride",
          "form": "tablet",
          "strength": "120 mg",
          "dose": "1 tablet",
          "frequencyPattern": "0+0+1",
          "timeSlots": [
            "night"
          ],
          "foodTiming": "not_specified",
          "duration": "7 days",
          "englishInstruction": "Take 1 tablet at night for 7 days.",
          "banglaInstruction": "রাতে ১টি ট্যাবলেট ৭ দিন খাবেন.",
          "confidence": 0.99,
          "needsReview": false,
          "reviewReason": ""
        },
        {
          "rawLine": "Aeron (Tab) 10mg | 0+0+1 | 7 days",
          "brandName": "Aeron",
          "genericName": "Montelukast Sodium",
          "form": "tablet",
          "strength": "10 mg",
          "dose": "1 tablet",
          "frequencyPattern": "0+0+1",
          "timeSlots": [
            "night"
          ],
          "foodTiming": "not_specified",
          "duration": "7 days",
          "englishInstruction": "Take 1 tablet at night for 7 days.",
          "banglaInstruction": "রাতে ১টি ট্যাবলেট ৭ দিন খাবেন.",
          "confidence": 0.98,
          "needsReview": false,
          "reviewReason": ""
        },
        {
          "rawLine": "Oxofylline (Tab) 400mg | 0+0+1 | 7 days | after meal",
          "brandName": "Oxofylline",
          "genericName": "Doxophylline",
          "form": "tablet",
          "strength": "400 mg",
          "dose": "1 tablet",
          "frequencyPattern": "0+0+1",
          "timeSlots": [
            "night"
          ],
          "foodTiming": "after_food",
          "duration": "7 days",
          "englishInstruction": "Take 1 tablet after meal at night for 7 days.",
          "banglaInstruction": "খাবারের পরে রাতে ১টি ট্যাবলেট ৭ দিন খাবেন.",
          "confidence": 0.96,
          "needsReview": false,
          "reviewReason": ""
        },
        {
          "rawLine": "Flamex (Tab) 400mg | 1+0+1 | 5 days | after meal",
          "brandName": "Flamex",
          "genericName": "Ibuprofen",
          "form": "tablet",
          "strength": "400 mg",
          "dose": "1 tablet",
          "frequencyPattern": "1+0+1",
          "timeSlots": [
            "morning",
            "night"
          ],
          "foodTiming": "after_food",
          "duration": "5 days",
          "englishInstruction": "Take 1 tablet after meal in the morning and night for 5 days.",
          "banglaInstruction": "খাবারের পরে সকাল ও রাতে ১টি ট্যাবলেট ৫ দিন খাবেন.",
          "confidence": 0.96,
          "needsReview": false,
          "reviewReason": ""
        }
      ],
      "nonMedicineFindings": [
        "Lab test: CBC with ESR",
        "Lab test: CRP"
      ]
    },
    {
      "id": "rx_handwritten_fever_headache_2026_06_29",
      "sourceImage": "5.jpg",
      "templateType": "handwritten clinic prescription",
      "patient": {
        "name": "Md. Mehedi Hasan Abir",
        "id": "",
        "age": "21 yr",
        "sex": "",
        "date": "29/06/26"
      },
      "doctor": {
        "name": "Dr. Mahfuzul Islam Sobuj (header)",
        "hospital": ""
      },
      "complaints": [
        "Fever",
        "Headache for 2 days"
      ],
      "vitals": {
        "bp": "120/80"
      },
      "possibleContext": [
        "Fever/headache/allergy/nasal symptom clue; confirm diagnosis with doctor"
      ],
      "medicines": [
        {
          "rawLine": "ORS",
          "brandName": "ORS",
          "genericName": "Oral Rehydration Salts",
          "form": "oral solution",
          "strength": "not specified",
          "dose": "as directed",
          "frequencyPattern": "as needed",
          "timeSlots": [
            "as_needed"
          ],
          "foodTiming": "not_applicable",
          "duration": "not specified",
          "englishInstruction": "Use ORS as directed for rehydration.",
          "banglaInstruction": "পানিশূন্যতা এড়াতে নির্দেশনা অনুযায়ী ORS খাবেন.",
          "confidence": 0.85,
          "needsReview": false,
          "reviewReason": ""
        },
        {
          "rawLine": "Unclear: Aex XR / Ace XR? | 1+1+1",
          "brandName": "Unclear Aex/Ace XR",
          "genericName": "unknown",
          "form": "tablet",
          "strength": "not specified",
          "dose": "1 tablet",
          "frequencyPattern": "1+1+1",
          "timeSlots": [
            "morning",
            "noon",
            "night"
          ],
          "foodTiming": "not_specified",
          "duration": "not specified",
          "englishInstruction": "This medicine name needs confirmation before use.",
          "banglaInstruction": "এই ওষুধের নাম ব্যবহারের আগে নিশ্চিত করতে হবে.",
          "confidence": 0.35,
          "needsReview": true,
          "reviewReason": "Handwriting unclear"
        },
        {
          "rawLine": "Tab. Fenadin 120mg | 0+0+1 | 1 week",
          "brandName": "Fenadin",
          "genericName": "Fexofenadine Hydrochloride",
          "form": "tablet",
          "strength": "120 mg",
          "dose": "1 tablet",
          "frequencyPattern": "0+0+1",
          "timeSlots": [
            "night"
          ],
          "foodTiming": "not_specified",
          "duration": "1 week",
          "englishInstruction": "Take 1 tablet at night for 1 week.",
          "banglaInstruction": "রাতে ১টি ট্যাবলেট ১ সপ্তাহ খাবেন.",
          "confidence": 0.82,
          "needsReview": false,
          "reviewReason": ""
        },
        {
          "rawLine": "Afrin nasal drop 0.05% | nasal use | 2 days",
          "brandName": "Afrin nasal drop",
          "genericName": "Oxymetazoline Hydrochloride",
          "form": "nasal drop",
          "strength": "0.05%",
          "dose": "verify drops per nostril",
          "frequencyPattern": "twice daily (unclear)",
          "timeSlots": [
            "morning",
            "night"
          ],
          "foodTiming": "not_applicable",
          "duration": "2 days",
          "englishInstruction": "Use the nasal drop as written, but confirm the exact number of drops.",
          "banglaInstruction": "নাকের ড্রপটি নির্দেশনা অনুযায়ী ব্যবহার করবেন, তবে কয় ফোঁটা তা নিশ্চিত করুন.",
          "confidence": 0.62,
          "needsReview": true,
          "reviewReason": "Dose/drops handwritten unclear"
        },
        {
          "rawLine": "Tab. Othin 20mg | 1+0+1 | 1 month? | before food?",
          "brandName": "Othin",
          "genericName": "unknown",
          "form": "tablet",
          "strength": "20 mg",
          "dose": "1 tablet",
          "frequencyPattern": "1+0+1",
          "timeSlots": [
            "morning",
            "night"
          ],
          "foodTiming": "before_food",
          "duration": "1 month (verify)",
          "englishInstruction": "Take 1 tablet before food in the morning and night; confirm duration.",
          "banglaInstruction": "খাবারের আগে সকাল ও রাতে ১টি ট্যাবলেট খাবেন; মেয়াদ নিশ্চিত করুন.",
          "confidence": 0.55,
          "needsReview": true,
          "reviewReason": "Brand/generic and duration need verification"
        }
      ],
      "nonMedicineFindings": [
        "Lab: CBC",
        "Dengue NS1 antigen",
        "X-ray PNS"
      ]
    },
    {
      "id": "rx_cmh_scabies_child_2025_06_12",
      "sourceImage": "6.jpg",
      "templateType": "CMH printed prescription",
      "patient": {
        "name": "Saima Binte Mamun",
        "personalId": "260207D1",
        "age": "5Y 7M 6D",
        "sex": "Female",
        "date": "06/12/2025 12:33 PM"
      },
      "doctor": {
        "name": "Anica Tabassum (stamp)",
        "hospital": "Combined Military Hospital Dhaka"
      },
      "diagnosis": [
        "Scabies"
      ],
      "possibleContext": [
        "Scabies treatment clue"
      ],
      "medicines": [
        {
          "rawLine": "PERMETHRIN CREAM 5% — apply neck to toe on day 1 and day 7, keep 10–12 hrs at night, wash off morning",
          "brandName": "Permethrin Cream",
          "genericName": "Permethrin",
          "form": "cream",
          "strength": "5%",
          "dose": "apply from neck to toe",
          "frequencyPattern": "day 1 and day 7",
          "timeSlots": [
            "night"
          ],
          "foodTiming": "not_applicable",
          "duration": "2 days / repeat on day 7",
          "englishInstruction": "Apply from neck to toe on day 1 and day 7 at night. Keep for 10–12 hours, then wash off in the morning.",
          "banglaInstruction": "১ম দিন ও ৭ম দিন রাতে গলা থেকে পা পর্যন্ত লাগাবেন। ১০–১২ ঘণ্টা রেখে সকালে ধুয়ে ফেলবেন.",
          "confidence": 0.99,
          "needsReview": false,
          "reviewReason": ""
        },
        {
          "rawLine": "Cefuroxime Syp — 2 tsf twice daily — 1 week",
          "brandName": "Cefuroxime Syrup",
          "genericName": "Cefuroxime",
          "form": "syrup",
          "strength": "not specified",
          "dose": "2 tsp",
          "frequencyPattern": "twice daily",
          "timeSlots": [
            "morning",
            "night"
          ],
          "foodTiming": "not_specified",
          "duration": "1 week",
          "englishInstruction": "Take 2 teaspoons twice daily for 1 week.",
          "banglaInstruction": "দিনে ২ বার ২ চা-চামচ করে ১ সপ্তাহ খাবেন.",
          "confidence": 0.95,
          "needsReview": false,
          "reviewReason": ""
        },
        {
          "rawLine": "CETIRIZINE SYRUP — 2 tsf once daily — 2 weeks — at night",
          "brandName": "Cetirizine Syrup",
          "genericName": "Cetirizine Hydrochloride",
          "form": "syrup",
          "strength": "not specified",
          "dose": "2 tsp",
          "frequencyPattern": "once daily",
          "timeSlots": [
            "night"
          ],
          "foodTiming": "not_specified",
          "duration": "2 weeks",
          "englishInstruction": "Take 2 teaspoons once daily at night for 2 weeks.",
          "banglaInstruction": "রাতে ১ বার ২ চা-চামচ করে ২ সপ্তাহ খাবেন.",
          "confidence": 0.97,
          "needsReview": false,
          "reviewReason": ""
        }
      ],
      "nonMedicineFindings": [
        "Advice contains scabies care instructions and anti-scabic soap"
      ]
    },
    {
      "id": "rx_cmh_orthopedic_pain_2026_03_29_2105",
      "sourceImage": "7.jpg",
      "templateType": "CMH printed prescription",
      "patient": {
        "name": "Forida Parvin",
        "personalId": "1816040W1",
        "age": "30Y 9M 19D",
        "sex": "Female",
        "date": "29/03/2026 09:05 PM"
      },
      "doctor": {
        "name": "Rafia Afroz (stamp)",
        "hospital": "Combined Military Hospital Dhaka"
      },
      "department": "Orthopedic OPD",
      "possibleContext": [
        "Musculoskeletal pain / orthopedic treatment clue; confirm diagnosis with doctor"
      ],
      "medicines": [
        {
          "rawLine": "Naproxen 375 mg + Esomeprazole 20 mg Tab | 1+0+1 | 5 days | After Meal",
          "brandName": "Naproxen + Esomeprazole",
          "genericName": "Naproxen + Esomeprazole",
          "form": "tablet",
          "strength": "375 mg + 20 mg",
          "dose": "1 tablet",
          "frequencyPattern": "1+0+1",
          "timeSlots": [
            "morning",
            "night"
          ],
          "foodTiming": "after_food",
          "duration": "5 days",
          "englishInstruction": "Take 1 tablet after meal in the morning and night for 5 days.",
          "banglaInstruction": "খাবারের পরে সকাল ও রাতে ১টি ট্যাবলেট ৫ দিন খাবেন.",
          "confidence": 0.99,
          "needsReview": false,
          "reviewReason": ""
        },
        {
          "rawLine": "Vitamin B1, B6 & B12 Tab | 0+0+1 | 1 month | After Meal",
          "brandName": "Vitamin B1 B6 B12",
          "genericName": "Thiamine + Pyridoxine + Cyanocobalamin",
          "form": "tablet",
          "strength": "not specified",
          "dose": "1 tablet",
          "frequencyPattern": "0+0+1",
          "timeSlots": [
            "night"
          ],
          "foodTiming": "after_food",
          "duration": "1 month",
          "englishInstruction": "Take 1 tablet after meal at night for 1 month.",
          "banglaInstruction": "খাবারের পরে রাতে ১টি ট্যাবলেট ১ মাস খাবেন.",
          "confidence": 0.98,
          "needsReview": false,
          "reviewReason": ""
        },
        {
          "rawLine": "Baclofen 10 mg Tab | 0+0+1 | 3 weeks | After Meal",
          "brandName": "Baclofen",
          "genericName": "Baclofen",
          "form": "tablet",
          "strength": "10 mg",
          "dose": "1 tablet",
          "frequencyPattern": "0+0+1",
          "timeSlots": [
            "night"
          ],
          "foodTiming": "after_food",
          "duration": "3 weeks",
          "englishInstruction": "Take 1 tablet after meal at night for 3 weeks.",
          "banglaInstruction": "খাবারের পরে রাতে ১টি ট্যাবলেট ৩ সপ্তাহ খাবেন.",
          "confidence": 0.99,
          "needsReview": false,
          "reviewReason": ""
        },
        {
          "rawLine": "Clonazepam 0.5mg Tab | 0+0+1 | 1 month | After Meal",
          "brandName": "Clonazepam",
          "genericName": "Clonazepam",
          "form": "tablet",
          "strength": "0.5 mg",
          "dose": "1 tablet",
          "frequencyPattern": "0+0+1",
          "timeSlots": [
            "night"
          ],
          "foodTiming": "after_food",
          "duration": "1 month",
          "englishInstruction": "Take 1 tablet after meal at night for 1 month.",
          "banglaInstruction": "খাবারের পরে রাতে ১টি ট্যাবলেট ১ মাস খাবেন.",
          "confidence": 0.99,
          "needsReview": false,
          "reviewReason": ""
        },
        {
          "rawLine": "Pregabalin 75 mg Cap | 1+0+1 | 1 month",
          "brandName": "Pregabalin",
          "genericName": "Pregabalin",
          "form": "capsule",
          "strength": "75 mg",
          "dose": "1 capsule",
          "frequencyPattern": "1+0+1",
          "timeSlots": [
            "morning",
            "night"
          ],
          "foodTiming": "not_specified",
          "duration": "1 month",
          "englishInstruction": "Take 1 capsule in the morning and night for 1 month.",
          "banglaInstruction": "সকাল ও রাতে ১টি ক্যাপসুল ১ মাস খাবেন.",
          "confidence": 0.99,
          "needsReview": false,
          "reviewReason": ""
        }
      ],
      "nonMedicineFindings": [
        "Advice: avoid heavy weight lift",
        "Avoid working with bent waist",
        "Back exercise",
        "Warm water compression twice daily for 20 minutes"
      ]
    },
    {
      "id": "rx_cmh_breathlessness_2026_03_29_2051",
      "sourceImage": "8.jpg",
      "templateType": "CMH printed prescription",
      "patient": {
        "name": "Forida Parvin",
        "personalId": "1816040W1",
        "age": "30Y 9M 19D",
        "sex": "Female",
        "date": "29/03/2026 08:51 PM"
      },
      "doctor": {
        "name": "Dr. Sinthia Tanzim Srayoshe",
        "hospital": "Combined Military Hospital Dhaka"
      },
      "chiefComplaint": [
        "Breathlessness"
      ],
      "possibleContext": [
        "Breathlessness/pulmonology referral clue; confirm diagnosis with doctor"
      ],
      "medicines": [
        {
          "rawLine": "Montelukast 10 mg Tab | 0+0+1 | 10 days | After Meal",
          "brandName": "Montelukast",
          "genericName": "Montelukast Sodium",
          "form": "tablet",
          "strength": "10 mg",
          "dose": "1 tablet",
          "frequencyPattern": "0+0+1",
          "timeSlots": [
            "night"
          ],
          "foodTiming": "after_food",
          "duration": "10 days",
          "englishInstruction": "Take 1 tablet after meal at night for 10 days.",
          "banglaInstruction": "খাবারের পরে রাতে ১টি ট্যাবলেট ১০ দিন খাবেন.",
          "confidence": 0.99,
          "needsReview": false,
          "reviewReason": ""
        },
        {
          "rawLine": "Pantoprazole 20 mg Tab | 1+0+1 | 10 days | Before Meal",
          "brandName": "Pantoprazole",
          "genericName": "Pantoprazole Sodium",
          "form": "tablet",
          "strength": "20 mg",
          "dose": "1 tablet",
          "frequencyPattern": "1+0+1",
          "timeSlots": [
            "morning",
            "night"
          ],
          "foodTiming": "before_food",
          "duration": "10 days",
          "englishInstruction": "Take 1 tablet before meal in the morning and night for 10 days.",
          "banglaInstruction": "খাবারের আগে সকাল ও রাতে ১টি ট্যাবলেট ১০ দিন খাবেন.",
          "confidence": 0.99,
          "needsReview": false,
          "reviewReason": ""
        }
      ],
      "nonMedicineFindings": [
        "Investigation: X-ray chest PA view",
        "Referred OPD: Pulmonology"
      ]
    },
    {
      "id": "rx_cmh_lbp_radiculopathy_2026_07_11",
      "sourceImage": "9.jpg",
      "templateType": "CMH printed prescription",
      "patient": {
        "name": "Forida Parvin",
        "personalId": "1816040W1",
        "age": "30Y 9M 19D",
        "sex": "Female",
        "date": "11/07/2026 10:16 AM"
      },
      "doctor": {
        "name": "Md Faruk Ahmad (stamp)",
        "hospital": "Combined Military Hospital Dhaka"
      },
      "diagnosis": [
        "LBP with radiculopathy left"
      ],
      "possibleContext": [
        "Back pain/radiculopathy treatment clue; confirm diagnosis with doctor"
      ],
      "medicines": [
        {
          "rawLine": "Naproxen 375 mg + Esomeprazole 20 mg Tab | 1+0+1 | 5 days | After Meal",
          "brandName": "Naproxen + Esomeprazole",
          "genericName": "Naproxen + Esomeprazole",
          "form": "tablet",
          "strength": "375 mg + 20 mg",
          "dose": "1 tablet",
          "frequencyPattern": "1+0+1",
          "timeSlots": [
            "morning",
            "night"
          ],
          "foodTiming": "after_food",
          "duration": "5 days",
          "englishInstruction": "Take 1 tablet after meal in the morning and night for 5 days.",
          "banglaInstruction": "খাবারের পরে সকাল ও রাতে ১টি ট্যাবলেট ৫ দিন খাবেন.",
          "confidence": 0.99,
          "needsReview": false,
          "reviewReason": ""
        },
        {
          "rawLine": "Pregabalin 25 mg Cap | 1+0+1 | 1 month | After Meal",
          "brandName": "Pregabalin",
          "genericName": "Pregabalin",
          "form": "capsule",
          "strength": "25 mg",
          "dose": "1 capsule",
          "frequencyPattern": "1+0+1",
          "timeSlots": [
            "morning",
            "night"
          ],
          "foodTiming": "after_food",
          "duration": "1 month",
          "englishInstruction": "Take 1 capsule after meal in the morning and night for 1 month.",
          "banglaInstruction": "খাবারের পরে সকাল ও রাতে ১টি ক্যাপসুল ১ মাস খাবেন.",
          "confidence": 0.99,
          "needsReview": false,
          "reviewReason": ""
        },
        {
          "rawLine": "Vitamin B1, B6 & B12 Tab | 0+0+1 | 1 month | After Meal",
          "brandName": "Vitamin B1 B6 B12",
          "genericName": "Thiamine + Pyridoxine + Cyanocobalamin",
          "form": "tablet",
          "strength": "not specified",
          "dose": "1 tablet",
          "frequencyPattern": "0+0+1",
          "timeSlots": [
            "night"
          ],
          "foodTiming": "after_food",
          "duration": "1 month",
          "englishInstruction": "Take 1 tablet after meal at night for 1 month.",
          "banglaInstruction": "খাবারের পরে রাতে ১টি ট্যাবলেট ১ মাস খাবেন.",
          "confidence": 0.98,
          "needsReview": false,
          "reviewReason": ""
        },
        {
          "rawLine": "Baclofen 10mg Tab | 0+0+1 | 3 weeks | After Meal",
          "brandName": "Baclofen",
          "genericName": "Baclofen",
          "form": "tablet",
          "strength": "10 mg",
          "dose": "1 tablet",
          "frequencyPattern": "0+0+1",
          "timeSlots": [
            "night"
          ],
          "foodTiming": "after_food",
          "duration": "3 weeks",
          "englishInstruction": "Take 1 tablet after meal at night for 3 weeks.",
          "banglaInstruction": "খাবারের পরে রাতে ১টি ট্যাবলেট ৩ সপ্তাহ খাবেন.",
          "confidence": 0.99,
          "needsReview": false,
          "reviewReason": ""
        },
        {
          "rawLine": "Calcium carbonate 500mg + Vitamin D Tab | 0+1+0 | 1 month | After Meal",
          "brandName": "Calcium carbonate + Vitamin D",
          "genericName": "Calcium Carbonate + Vitamin D",
          "form": "tablet",
          "strength": "500 mg + Vitamin D",
          "dose": "1 tablet",
          "frequencyPattern": "0+1+0",
          "timeSlots": [
            "noon"
          ],
          "foodTiming": "after_food",
          "duration": "1 month",
          "englishInstruction": "Take 1 tablet after meal at noon for 1 month.",
          "banglaInstruction": "খাবারের পরে দুপুরে ১টি ট্যাবলেট ১ মাস খাবেন.",
          "confidence": 0.97,
          "needsReview": false,
          "reviewReason": ""
        },
        {
          "rawLine": "Clonazepam 0.5 mg Tab | 0+0+1 | 1 month | After Meal",
          "brandName": "Clonazepam",
          "genericName": "Clonazepam",
          "form": "tablet",
          "strength": "0.5 mg",
          "dose": "1 tablet",
          "frequencyPattern": "0+0+1",
          "timeSlots": [
            "night"
          ],
          "foodTiming": "after_food",
          "duration": "1 month",
          "englishInstruction": "Take 1 tablet after meal at night for 1 month.",
          "banglaInstruction": "খাবারের পরে রাতে ১টি ট্যাবলেট ১ মাস খাবেন.",
          "confidence": 0.99,
          "needsReview": false,
          "reviewReason": ""
        }
      ],
      "nonMedicineFindings": [
        "Investigation: X-ray LS spine flexion & extension view",
        "Advice: avoid heavy weight lift, back exercise, warm water compression"
      ]
    }
  ],
  "sources": {
    "medex_carboxymethylcellulose": "MedEx: Carboxymethylcellulose Sodium / Aquafresh PF brand list",
    "medex_napa": "MedEx: Napa 500 mg Tablet / Paracetamol",
    "medex_fexofenadine": "MedEx: Fexofenadine Hydrochloride brand list including Fexo",
    "medex_fenadin": "MedEx: Fenadin 120 mg Tablet / Fexofenadine Hydrochloride",
    "hpl_furotil_plus": "Healthcare Pharmaceuticals: Furotil Plus contains Cefuroxime Axetil + Potassium Clavulanate",
    "medex_aeron": "MedEx: Aeron 10 mg Tablet / Montelukast Sodium",
    "medex_doxophylline": "MedEx: Doxophylline brand list including Oxofyline",
    "aci_flamex": "ACI Pharma: Flamex is Ibuprofen",
    "medex_afrin": "MedEx: Afrin 0.05% Nasal Drop / Oxymetazoline Hydrochloride",
    "medex_permethrin": "MedEx: Permethrin brand list / 5% cream",
    "medex_pantoprazole": "MedEx: Pantoprazole Sodium brand list",
    "medex_calcium": "MedEx: Calcium Carbonate / calcium supplement brand list",
    "medex_b1_b6_b12": "MedEx: Vitamin B1, B6 & B12 composition",
    "medex_baclofen": "MedEx: Baclofen generic page",
    "medex_rivotril": "MedEx: Rivotril 0.5 mg / Clonazepam",
    "medex_pregabalin": "MedEx: Pregabalin generic page",
    "medex_montelukast": "MedEx: Montelukast Sodium generic page",
    "clinical_common": "Common prescription terminology; verify before clinical use",
    "manual_review": "Could not confidently verify from provided image/source"
  }
} as const;

export default medcheckPrescriptionTrainingDatabase;
